import {User} from "../api/accessControl/User.ts";
import {AuthState, isPendingOnboardingUser, PendingOnboardingUser} from "../api/accessControl/AuthState.ts";
import {BackendApi} from "../api/api.ts";
import {HTTPCurrentUserRepository} from "../api/accessControl/HTTPCurrentUserRepository.ts";

export async function createUser(api: BackendApi): Promise<User> {
    const userRepository = new HTTPCurrentUserRepository(api);
    return await userRepository.getCurrentUser()
}

function isUserNotFoundError(error: unknown): boolean {
    if (typeof error !== 'object' || error === null) {
        return false;
    }

    const detail = 'detail' in error ? String((error as { detail: unknown }).detail) : '';
    return detail.includes('User not found');
}

export async function processCurrentAuthState(
    firebaseUser: any,
    onSuccessfulAuthenticationCallback: (user: User, api: BackendApi) => void
): Promise<AuthState> {
    if (!firebaseUser) {
        return null;
    }

    try {
        const FirebaseUserToken = await firebaseUser.getIdToken();
        const api = new BackendApi(FirebaseUserToken);
        const user = await createUser(api);
        await onSuccessfulAuthenticationCallback(user, api);
        return user;
    } catch (err) {
        if (isUserNotFoundError(err)) {
            const pendingUser: PendingOnboardingUser = {
                kind: 'pending_onboarding',
                firebaseUser,
            };
            return pendingUser;
        }

        console.log('An error occurred' + err);
        throw err;
    }
}

export {isPendingOnboardingUser};
